<template>
    <z-scrollDiv class="form-wrap">
        <div class="form-item">
            <div class="item-title">申请BU：</div>
            <div class="item-text">{{ data.bu_name }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">岗位名称：</div>
            <div class="item-text">{{ data.position_name }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">增岗类型：</div>
            <div class="item-text">{{ apply.postType[data.req_type] }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">增岗人数：</div>
            <div class="item-text">{{ data.trans_amount }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">岗位需求：</div>
            <div class="item-text">{{ data.position_description }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">申请理由：</div>
            <div class="item-text">{{ data.remark }}</div>
        </div>
        <div class="form-item" v-if="data.status!=1">
            <div class="item-title">审核说明：</div>
            <div class="item-text">{{ data.result }}</div>
        </div>


        <sliderHistoty :data="data.req"></sliderHistoty>

        <!-- 审核 -->
        <div v-if="data.status==1 && $route.name!='my-application'"  v-form:apply-add>
            <div class="form-line" text="审核处理"></div>

            <div class="form-item">
                <div class="item-title">审核说明：</div>
                <div class="item-wrap">
                    <textarea rule="reason" v-arg="'审核说明'" v-tar="examine.result" v-model="examine.result" placeholder="请输入审核说明"></textarea>
                </div>
            </div>

            <div class="form-footer">
                <el-button type="primary" @click="checkPass">通 过</el-button>
                <el-button type="primary" @click="checkNotPass">不通过</el-button>
            </div>
        </div>

        <!-- 重新提交 -->
        <div v-if="data.status == 3 &&  $route.name=='my-application'" v-form:position-again>
            <div class="form-line" text="申请"></div>

            <div class="form-item">
                <div class="item-title">岗位名称：</div>
                <div class="item-text">
                    <el-select v-tar="resub.add_positionId" rule="noVal" v-model="resub.add_positionId"  placeholder="请选择">
                        <z-limitOption v-for="item in all_posts" :key="item.id" :label="item.positionName" :value="item.id">
                        </z-limitOption>
                    </el-select>
                    <el-button class="add-post" icon="plus" @click="openEdit()"></el-button>
                    <!--添加职位-->
                    <transition name="fade">
                        <div class="add-input" v-show="add_inputFlag" @mouseover="add_hover = true" @mouseleave="add_hover = false">
                            <input v-model="add_editText" @keyup.enter="uploadEdit()" @blur="hideEdit()" ref="post_input" placeholder="请输入岗位名称">
                            <div class="add-btns">
                                <i @click="clearEdit()" class="el-icon-close"></i>
                                <i @click="uploadEdit()" v-show="!add_up_ing" ref="add_check" class="el-icon-check"></i>
                                <i v-show="add_up_ing" class="el-icon-loading"></i>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>

            <div class="form-item">
                <div class="item-title">增岗类型：</div>
                <div class="item-text">
                    <el-select rule="noVal" v-tar="resub.add_typeId" v-model="resub.add_typeId" placeholder="请选择">
                        <el-option v-for="(val,id) in apply.postType" :key="id" :label="val" :value="id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title">增岗人数：</div>
                <div class="item-text">
                    <el-input rule="noVal number" v-tar="resub.add_num"  v-model="resub.add_num" placeholder="请输入数字"></el-input>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title">岗位需求：</div>
                <div class="item-wrap">
                    <textarea rule="reason" v-arg="['岗位需求']" v-tar="resub.add_require" v-model="resub.add_require" placeholder="请输入岗位需求"></textarea>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title">申请理由：</div>
                <div class="item-wrap">
                    <textarea rule="reason" v-arg="['申请理由']" v-tar="resub.add_reason"  v-model="resub.add_reason" placeholder="请输入申请理由"></textarea>
                </div>
            </div>
            <div class="form-footer">
                <el-button type="primary" @click="subAgain">重新提交</el-button>
            </div>

        </div>

    </z-scrollDiv>
</template>

<script>
    import sliderHistoty from "src/components/slider/slider_history.vue"
    import { mapState } from "vuex"

    export default {
        props:["sliderArg","data","resub","examine"],
        components:{
            sliderHistoty,
        },
        data(){
            return {
                all_posts:[],       //公司岗位列表
                add_inputFlag: false,  //增岗 输入框
                add_hover: false,      //增岗 悬浮判断器
                add_editText: "",    //增岗 内容
                add_up_ing: false,   //上传新建职位判断器
            }
        },

        computed:{
            ...mapState(["apply"]),
        },

        watch:{
            data(val){
                let count = 0;
                for(let i in val){
                    count++;
                };
                if(count == 0){
                    this.$form.clear("position-again");
                    this.$form.clear("apply-add");
                }
            },
        },

        created(){
            this.$func.getPost(true,data =>{ //拿公司岗位
                this.all_posts = data;
            });
        },

        methods:{
            checkPass(){
                let res = this.$form.check("apply-add");
                if(!res){
                    return;
                }

                this.sliderArg.inside_index = 0;
				this.sliderArg.insideFlag = true;
                // this.$emit('pass');
            },
            checkNotPass(){
                let res = this.$form.check("apply-add");
                if(!res){
                    return;
                }

                this.sliderArg.inside_index = 1;
				this.sliderArg.insideFlag = true;
                // this.$emit('notpass');
            },
            subAgain(){  //重提交
                let res = this.$form.check("position-again");
                if(!res){
                    return;
                }

                let name,id;
                if(isNaN(this.resub.add_positionId - 0)){
                    name = this.resub.add_positionId;
                }else{
                    id = this.resub.add_positionId;
                }

                let url = `api/manager/new_position_req/${this.data.id}`;
                this.$http.put(url,{
                    position_id: id,
                    position_name:name,
                    req_type:this.resub.add_typeId,
                    trans_amount:this.resub.add_num,
                    position_description:this.resub.add_require,
                    remark:this.resub.add_reason,
                    // name_id:this.resub.add_positionId,
                }).then(res=>{
                    if(res.status == 200){
                        this.successTip("重新提交成功");
                        this.$emit("refresh");
                    }
                }).catch(error=>{
                    this.errorTip("提交失败");
                });

            },

            // ****增岗功能
            openFocus(str) {  //弹窗后，表单获得焦点
                setTimeout(() => {
                    this.$refs[str].focus();
                }, 0);
            },
            openEdit() {  //打开编辑框
                this.add_inputFlag = true;
                this.openFocus("post_input");
            },
            closeEdit() { //关闭编辑框
                this.add_inputFlag = false;
                this.clearEdit();
            },
            hideEdit() {  //编辑框失去焦点
                if (this.add_hover == true) {
                    this.openFocus("post_input");
                    return;
                }

                this.closeEdit();
            },
            clearEdit() {  //清空编辑框数据
                this.add_editText = "";
            },
            uploadEdit() {  //上传新增职位
                if (this.add_up_ing) {
                    return;
                }
                this.add_up_ing = true;

                let name = this.add_editText;
                if (name.trim() == "") {
                    this.errorTip("岗位不能为空");
                    this.add_up_ing = false;
                    return;
                }

                this.all_posts.push({
                    id:name,
                    positionName:name,
                });

                this.resub.add_positionId = name;
                this.closeEdit();
                this.add_up_ing = false;
            },
        }
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/slider.less";

    // 增岗职位名称部分
    .add-post {
        width: 30px;
        border-color: #d9d9d9;
        color: #bfcbd9;
        transition: .2s cubic-bezier(.645, .045, .355, 1);
        &:hover {
            border-color: #8391a5;
            color: #8391a5;
        }
    }

    // 输入职位
    .add-input {
        position: absolute;
        width: 210px;
        top: calc(~"100% + 5px");
        z-index: 5;
        background: #fff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        input {
            padding: 12px 8px;
            font-size: 12px;
        }
        .add-btns {
            text-align: right; // line-height: 15px;
            padding: 6px 0;
            border-top: 1px solid #d9d9d9;
            font-size: 0;
            @m: 10px;

            i {
                cursor: pointer;
                display: inline-block;
                padding: 3px 0;
                margin: 0 @m;
                position: relative;
                font-size: 12px;
                transform: scale(0.8);
                vertical-align: middle;
                width: 12px;
                &:nth-of-type(1):after {
                    content: "";
                    display: block;
                    width: 1px;
                    height: 100%;
                    background: #999;
                    position: absolute;
                    right: 0 - @m - 6px;
                    top: 0; // border-right: 1px solid #999;
                }
            }
        }
        .el-icon-close {
            transition: 0.2s;
            &:hover {
                color: #ff6b6b;
            }
        }
        .el-icon-check {
            transition: 0.2s;
            &:hover {
                color: #108ee9;
            }
        }
        .el-icon-loading {
            color: #108ee9;
        }
    }
</style>





// WEBPACK FOOTER //
// sliderAdd.vue?71bb71ad